import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Linkify from 'react-linkify';
import InboxMessageProp from '../../../../../propTypes/inboxMessageProp';
import translate from '../../../../../../../commonComponents/translate';
import {
  colors,
  INBOX_MSG_TYPE,
} from '../../../../../../../services/utilityFunctions';
import InboxContainer from '../InboxContainer';
import SurveyIcon from '../icons/SurveyIcon';
import EventIcon from '../icons/EventIcon';
import SurveyQuestionIcon from '../icons/SurveyQuestionIcon';

function SurveyMessage({ t, message }) {
  const { survey, surveyContext, createdAt, info } = message;

  const handleClick = useCallback(() => {
    if (!survey?._id) {
      return;
    }

    let url = `/survey/${survey._id}`;
    if (surveyContext?._id) {
      url += `?context=${surveyContext._id}`;
    }
    window.location.href = url;
  }, [survey?._id, surveyContext?._id]);

  if (!survey) {
    return null;
  }

  let description =
    surveyContext?.description || survey?.description || info || '';
  let link;

  if (!surveyContext || surveyContext.endDate < Date.now()) {
    description += '\n';
    description += t('inbox_event_closed');
  } else if (surveyContext.isSubmitted) {
    description += '\n';
    description += t('inbox_survey_answered');
  } else {
    link =
      message?.type === INBOX_MSG_TYPE.EVENT
        ? t('inbox_answerEvent')
        : t('inbox_answerNow');
  }

  const getTitle = () => {
    switch (message.type) {
      case INBOX_MSG_TYPE.SURVEY:
      case INBOX_MSG_TYPE.HIGHLIGHT_SURVEY_QUESTION:
        return message.title || survey?.title || '';
      case INBOX_MSG_TYPE.EVENT:
      default:
        return message.title;
    }
  };

  const getIcon = () => {
    switch (message.type) {
      case INBOX_MSG_TYPE.EVENT:
        return EventIcon;
      case INBOX_MSG_TYPE.HIGHLIGHT_SURVEY_QUESTION:
        return SurveyQuestionIcon;
      case INBOX_MSG_TYPE.SURVEY:
      default:
        return SurveyIcon;
    }
  };

  return (
    <InboxContainer
      style={{
        '--news-item-bg': colors('inverse'),
        '--news-item-title': colors('dynamic'),
        '--news-item-text': '#6F6C80',
      }}
      title={getTitle()}
      createdAt={createdAt}
      link={link}
      image={getIcon()}
      onClick={link ? handleClick : undefined}
    >
      <span style={{ whiteSpace: 'pre-wrap' }}>
        <Linkify>{description}</Linkify>
      </span>
    </InboxContainer>
  );
}

SurveyMessage.propTypes = {
  t: PropTypes.func.isRequired,
  message: PropTypes.shape(InboxMessageProp.propType).isRequired,
};

export default translate(SurveyMessage);
